"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ = require("./");
var getMinorNames = function getMinorNames(student) {
  if (student.specialization === '5') {
    return student.minors.map(function (a) {
      return "".concat(a.otherMinor || a.minorName, " (Intended)");
    }).join(', ');
  }
  return student.minors.map(function (a) {
    var _a$minorConcentration, _a$minorSecondConcent;
    return (a.otherMinor || a.minorName) + (0, _.getConcentrations)([a === null || a === void 0 ? void 0 : (_a$minorConcentration = a.minorConcentration) === null || _a$minorConcentration === void 0 ? void 0 : _a$minorConcentration.trim(), a === null || a === void 0 ? void 0 : (_a$minorSecondConcent = a.minorSecondConcentration) === null || _a$minorSecondConcent === void 0 ? void 0 : _a$minorSecondConcent.trim()]);
  }).join(', ');
};
var _default = getMinorNames;
exports.default = _default;